import React from "react";
import { Typography, Box } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useEmployeeProfilesQuery } from "Hooks/useEmployeeProfilesQueryContext";
import { DPEmployeeProfiles } from "Shared/types/EmployeeProfiles";

const getSearchResultsText = (
  loading: boolean,
  employeeProfilesResponse: DPEmployeeProfiles
) => {
  if (loading) {
    return (
      <>
        <Box fontWeight="fontWeightBold" display="inline">
          Fetching
        </Box>{" "}
        results
      </>
    );
  }
  const displayedMatches = employeeProfilesResponse.items.length;
  const totalMatches = employeeProfilesResponse.totalCount;
  const matches =
    totalMatches > 0 ? (
      <>
        <Box fontWeight="fontWeightBold" display="inline">
          {displayedMatches}
        </Box>{" "}
        of{" "}
        <Box fontWeight="fontWeightBold" display="inline">
          {totalMatches}
        </Box>
      </>
    ) : (
      <Box fontWeight="fontWeightBold" display="inline">
        0
      </Box>
    );
  return (
    <>
      {matches} {totalMatches === 1 ? "result" : "results"}
    </>
  );
};

const SearchResultsText = () => {
  const { employeeProfilesResponse, loading } = useEmployeeProfilesQuery();
  const searchResultsCopy = getSearchResultsText(
    loading,
    employeeProfilesResponse
  );

  return (
    <FormHelperText id="search-help-text" component="div">
      <Typography variant="body1" component="div">{searchResultsCopy}</Typography>
    </FormHelperText>
  );
};

export default SearchResultsText;
